import { render, staticRenderFns } from "./block-presentation.vue?vue&type=template&id=2152d85b&scoped=true&"
import script from "./block-presentation.vue?vue&type=script&lang=js&"
export * from "./block-presentation.vue?vue&type=script&lang=js&"
import style0 from "./block-presentation.vue?vue&type=style&index=0&id=2152d85b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2152d85b",
  null
  
)

component.options.__file = "block-presentation.vue"
export default component.exports